import { useEffect } from "react";
import { AhoyEventsTable } from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";

export default function AhoyEvents() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Événements Ahoy");
  }, []);

  return <AhoyEventsTable />;
}
